import React from 'react';
import { SHIP_TITLE_PREFIX, SHIP_ROUTE_PREFIX } from '../../modules/fulfillment/consts';

import MainTabs from '../../modules/fulfillment/components/FulfillmentMainTabsLayout';

export default {
    name: 'shippingManifest',
    before: [],
    after: [],
    setup: (app) => {
        const id = 'shippingManifest';
        const label = 'Manifest';
        const route = `/${SHIP_ROUTE_PREFIX}/manifest`;
        const permission = 'fulfillments.index';

        app.fulfillmentShipTabs.addItem(id, {
            id,
            label,
            title: `${SHIP_TITLE_PREFIX} > ${label}`,
            link: route,
            permission,
            position: 'right',
            order: 90,
        });
        app.routes.addItem(id, {
            path: route,
            title: label,
            permission,
            props: () => ({}),
            loader: () => import('./packages/ShippingManifest/core'),
            render: (Component) =>
                function (props) {
                    return (
                        <MainTabs showCartFilter={false} showAssignUserFilter={false} {...props} name={id}>
                            <Component {...props} />
                        </MainTabs>
                    );
                },
        });
    },
};
